import React, { FunctionComponent, useCallback } from 'react'
import { Container, Logo, Subtitle, SubtitleInfo, Title } from './styles'
import { Button, Card, Grid, Hidden } from '@material-ui/core'
import { colors } from '../../../../../shared/styles/colors'
import { ArrowLeftIcon } from '@material-ui/pickers/_shared/icons/ArrowLeftIcon'
import { useCartao } from '../../../hooks/useCartao'
import { useAuth } from '../../../../auth/hooks/auth'
import { numberToCurrency } from '../../../../../shared/utils/formatters'
import logoTmovPayGreen from './../../../../../shared/assets/images/logoTmovPayGreen.svg'
import { isValidValue } from '../../../../../shared/utils/validates'
import { useHistory } from 'react-router-dom'
import PagamentoRoutes from '../../../utils/PagamentoRoutes'

interface CartaoNewProp {
  onGoBack?: () => void
}

const CartaoNew: FunctionComponent<CartaoNewProp> = ({ onGoBack }) => {
  const { cartao } = useCartao()
  const { name } = useAuth()
  const history = useHistory()

  const handleBackButton = useCallback(() => {
    if (onGoBack) {
      onGoBack()
    } else {
      history.replace(PagamentoRoutes.PAGAMENTO, {
        reloadHomePagamento: false,
      })
    }
  }, [onGoBack])

  return (
    <Container>
      <Grid
        container
        alignContent="center"
        justifyContent={'center'}
        alignItems={'center'}
        style={{
          height: 48,
          borderRadius: 4,
        }}
      >
        <Grid
          item
          xs={3}
          sm={3}
          md={2}
          lg={2}
          xl={2}
          style={{
            borderRadius: 4,
          }}
        >
          <Button
            variant={'outlined'}
            style={{
              textTransform: 'capitalize',
              color: colors.green,
              borderColor: colors.green,
              height: 48,
              backgroundColor: colors.white,
              width: '100%',
            }}
            startIcon={<ArrowLeftIcon />}
            onClick={handleBackButton}
          >
            Voltar
          </Button>
        </Grid>
        <Grid
          item
          xs={9}
          sm={9}
          md={10}
          lg={10}
          xl={10}
          alignItems={'center'}
          style={{
            height: '100%',
            borderRadius: 4,
            paddingLeft: 16,
            display: 'flex',
          }}
        >
          <Card
            style={{
              height: 48,
              width: '100%',
              display: 'flex',
            }}
          >
            <Grid
              container
              spacing={0}
              style={{
                display: 'flex',
                alignItems: 'center',
                textAlign: 'center',
              }}
            >
              <Grid item xs={6} sm={6} md={5} lg={6} xl={6}>
                <Title>{name}</Title>
              </Grid>
              <Grid item xs={3} sm={3} md={2} lg={2} xl={2}>
                <Subtitle>Saldo: </Subtitle>
                <SubtitleInfo>
                  {isValidValue(cartao?.saldo)
                    ? numberToCurrency(cartao?.saldo?.valor_saldo_disponivel)
                    : '-'}
                </SubtitleInfo>
              </Grid>
              <Grid item xs={3} sm={3} md={2} lg={2} xl={2}>
                <Subtitle>Cartão: </Subtitle>
                <SubtitleInfo>{cartao?.identificador ?? '-'}</SubtitleInfo>
              </Grid>

              <Hidden smDown>
                <Grid item xs={2} sm={2} md={3} lg={2} xl={2}>
                  <Logo src={logoTmovPayGreen} />
                </Grid>
              </Hidden>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </Container>
  )
}

export default CartaoNew
